import lodash from "lodash";
import store from "../../../../store";
import { has } from "../../../../utils/menu-context";
import { callHazSpecies } from "./inform-product/inform-product.logic";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (
                record.createBy === store.state.resource.auth.info.user?.username
                // || (record.createBy === "anonymousUser" && record.refInformTemp?.refUser?.username === store.state.resource.auth.info.user?.username)
                || (record.refInformTemp?.refUser?.username === store.state.resource.auth.info.user?.username)
            ) {
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canWaitReceive: ({ record }) => {
            let result = false;
            if (
                (record.createBy === store.state.resource.auth.info.user?.username ||
                    (record.createBy === "anonymousUser" &&
                        record.refInformTemp?.refUser?.username === store.state.resource.auth.info.user?.username)) &&
                !record.isOfficerCreate
            ) {
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canWaitApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (record.isOfficerCreate) {
                if (["draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            const userInfo = store.state.resource.auth.info?.user;
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    if (record.refToApproveBy?.username === userInfo.username) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canSendNsw: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            const userInfo = store.state.resource.auth.info?.user;
            if (has({ menuContext, key: "forApprove" })) {
                if (["approve"].includes(record.refStatus?.key)) {
                    if (record.refToApproveBy?.username === userInfo.username) {
                        if (!record.isNswProcess && (!record.nswMessageId || ["REJECT", "ERROR", "LicensePerInvoiceError", "LicenseCancelError"].includes(record.nswLicenseResponseMessageType))) {
                            result = true || result;
                        }
                    }
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["approve"].includes(record.refStatus?.key)) {
                    if (!record.isNswProcess && (!record.nswMessageId || ["REJECT", "ERROR", "LicensePerInvoiceError", "LicenseCancelError"].includes(record.nswLicenseResponseMessageType))) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canReStatus: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                if (["waitReceive"].includes(record.refStatus?.key) && !record.refInformTemp.eformCode) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canReport: ({ record }) => {
            return !["draft"].includes(record.refStatus?.key);
        }
    };
};

export const createConditionForm = ({ dataKey }) => {
    const prefix = dataKey ? `${dataKey}.` : "";
    const prefixRegExp = dataKey ? `${dataKey}\\.` : "";
    return [
        {
            check: ({ field }) => {
                return [
                    `${prefix}refDepartment.nameEn`,
                    `${prefix}lastStatus.waitReceive.0.statusDatetime`,
                    `${prefix}lastStatus.draft.0.statusDatetime`,
                    `${prefix}lastStatus.waitApprove.0.statusDatetime`,
                    `${prefix}refInformTemp.refUserCompany.companyNameEn`,
                    `${prefix}refInformTemp.refUser.fullNameEn`,
                    `${prefix}refInformTemp.refUserCompany.addresses.0.addrTh`,
                    `${prefix}refInformTemp.refUser.addresses.0.addrTh`
                ].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [`${prefix}refInformTemp.refUserCompany.idCard`].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [`${prefix}refInformTemp.refUser.idCard`].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [`${prefix}refRequestType`].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return [`${prefix}refDocGenType`, `${prefix}requestCode`].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return [`${prefix}refInformTemp.approveCode`].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return [`${prefix}refInformTemp.refUserCompany`, `${prefix}refDepartment`].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return [`${prefix}refInformTemp.refUser`].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return [`${prefix}refInform`].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2", "3", "4"].includes(modelRef.refRequestType?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return [`${prefix}refInformTemp.refOperation`].includes(field?.key);
            },
            visibleField: commonVisibleField({ invisibleRequestDocs: ["18", "19"] }),
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return [`${prefix}requestCodeTitle`].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !!modelRef.requestCode;
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [`${prefix}refInformTemp.eformCode`].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !!modelRef.refInformTemp?.eformCode;
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [`${prefix}refInform.approveCode`].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !!modelRef.refInform?.approveCode && ["1"].includes(modelRef.refRequestType?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refInformTemp.effectiveDate",
                    "refInformTemp.approveManualDate",
                    // "refInformTemp.expireDate"
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    if (["2", "3", "4"].includes(modelRef.refRequestType?.key) && modelRef.refDocGenType?.key !== "2") {
                        return { ...common, disabled: true };
                    }
                    return common;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [`${prefix}lastStatus.forRequestRemark.0.remark`].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    common.disabled = true;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [`${prefix}lastStatus.forReceiveRemark.0.remark`].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    undefined,
                    "draft",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refInformTemp\\.(importExportDate|refTransportByWay|vehicleNo|containerNo|sealNo|refOriginDestinationCountry|refImportCheckpoint|refExportCheckpoint|refPassCustoms)(2)?$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refInformTemp\\.(refTransportObjective)$`, "g").test(field?.key);
            },
            visibleField: commonVisibleField({ invisibleRequestDocs: ["02"] }),
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refInformTemp\\.(refTransportObjective2)$`, "g").test(field?.key);
            },
            visibleField: () => false
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.(invoiceCode|invoiceDate|invoiceSeq)$`, "g").test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.(refCoordinateCustoms)$`, "g").test(field?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["3", "4"]
                })({ modelRef, initialModel });
                if (["02"].includes(modelRef.refRequestDoc?.key)) {
                    if (modelRef.refRequestType?.key === "2") {
                        common.disabled = true;
                    }
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.(nature)$`, "g").test(field?.key);
            },
            visibleField: commonVisibleField({ invisibleRequestDocs: ["16", "17", "18", "19", "20"] }),
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["3", "4"]
                })({ modelRef, initialModel });
                if (["02"].includes(modelRef.refRequestDoc?.key)) {
                    if (modelRef.refRequestType?.key === "2") {
                        common.disabled = true;
                    }
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.(refHazSpecies)$`, "g").test(field?.key);
            },
            visibleField: commonVisibleField({ invisibleRequestDocs: ["02", "19"] }),
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["3", "4"]
                })({ modelRef, initialModel });
                if (["18"].includes(modelRef.refRequestDoc?.key)) {
                    common.list = ({ searchQuery }) =>
                        callHazSpecies({ searchQuery }).then(items => items.filter(item => ["1", "2"].includes(item.key)));
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.(refHazObject|refOriginDestinationCountry|manufacturer|tradeName)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel, model }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["3", "4"]
                })({ modelRef, initialModel });
                if (["16", "17"].includes(modelRef.refRequestDoc?.key)) {
                    if (common.disabled !== true) {
                        common.disabled = viewOnly || model.refHazSpecies?.key !== "1";
                    }
                } else if (["02"].includes(modelRef.refRequestDoc?.key)) {
                    if (modelRef.refRequestType?.key === "2") {
                        common.disabled = true;
                    }
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.(refStorageLocation)$`, "g").test(field?.key);
            },
            visibleField: ({ props, modelRef, model }) => {
                const { informKey } = props;
                const inform = informKey ? lodash.get(modelRef, informKey) : modelRef.refInformTemp;
                return (
                    (["16", "17"].includes(inform?.refRequestDoc?.key) && model.refHazSpecies?.key === "1") ||
                    ["02"].includes(inform?.refRequestDoc?.key)
                );
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.(storageName)$`, "g").test(field?.key);
            },
            visibleField: ({ props, modelRef }) => {
                const { informKey } = props;
                const inform = informKey ? lodash.get(modelRef, informKey) : modelRef.refInformTemp;
                return (["02"].includes(inform?.refRequestDoc?.key));
            },
            inputPropField2: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            }),
            inputPropField: ({ modelRef, initialModel, model }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["3", "4"]
                })({ modelRef, initialModel });

                if (["02"].includes(modelRef.refRequestDoc?.key) && model?.refStorageLocation?.id && model?.storageName) {
                    common.disabled = true;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.(formula)$`, "g").test(field?.key);
            },
            visibleField: ({ props, modelRef, model }) => {
                const { informKey } = props;
                const inform = informKey ? lodash.get(modelRef, informKey) : modelRef.refInformTemp;
                return (
                    (["16", "17"].includes(inform?.refRequestDoc?.key) && model.refHazSpecies?.key === "1") ||
                    ["02", "18", "19"].includes(inform?.refRequestDoc?.key)
                );
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["3", "4"]
                })({ modelRef, initialModel });
                if (["02"].includes(modelRef.refRequestDoc?.key)) {
                    if (modelRef.refRequestType?.key === "2") {
                        common.disabled = true;
                    }
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.(refHaz)$`, "g").test(field?.key);
            },
            visibleField: ({ props, modelRef, model }) => {
                const { informKey } = props;
                const inform = informKey ? lodash.get(modelRef, informKey) : modelRef.refInformTemp;
                return ["16", "17"].includes(inform?.refRequestDoc?.key) && model.refHazSpecies?.key !== "1";
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return (
                    new RegExp(`^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.(refHazLicense\\.approveCode)$`, "g").test(field?.key) ||
                    new RegExp(`^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.quantityRemaining$`, "g").test(field?.key) ||
                    new RegExp(`^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.refHaz\\.mainSubStances$`, "g").test(field?.key) ||
                    new RegExp(`^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.refHaz\\.tradeNameTh$`, "g").test(field?.key)
                );
            },
            visibleField: ({ props, modelRef, model }) => {
                const { informKey } = props;
                const inform = informKey ? lodash.get(modelRef, informKey) : modelRef.refInformTemp;
                return ["16", "17"].includes(inform?.refRequestDoc?.key) && model.refHazSpecies?.key !== "1";
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.productQties\\.[^\\.]+\\.(refStorageLocation|refPackagingCharacteristic)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.productQties\\.[^\\.]+\\.(qty|numberOfPackage|packageSize|amount)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel, model }) => {
                const { viewOnlyInspection } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["3", "4"]
                })({ modelRef, initialModel });
                if (
                    [undefined, "draft", "reEditOfficer", "waitRelease"].includes(modelRef.refStatus?.key) &&
                    viewOnlyInspection === false &&
                    model.enable
                ) {
                    return { ...common, disabled: false };
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.productQties\\.[^\\.]+\\.(netWeight)$`, "g").test(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel, model, informProduct }) => {
                const { viewOnly, viewOnlyInspection } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["3", "4"]
                })({ modelRef, initialModel });
                if (
                    [undefined, "draft", "reEditOfficer", "waitRelease"].includes(modelRef.refStatus?.key) &&
                    viewOnlyInspection === false &&
                    model.enable
                ) {
                    return { ...common, disabled: false };
                }
                if (["16", "17"].includes(modelRef.refRequestDoc?.key)) {
                    if (common.disabled !== true) {
                        common.disabled = viewOnly || (informProduct.refHazSpecies?.key !== "1" && !model.refStorageLocationSub);
                    }
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.productQties\\.[^\\.]+\\.(refStorageLocationSub|refStorageLocationSubItem)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.productQties\\.[^\\.]+\\.(refQtyUnit|refPackageUnit)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.productQties\\.[^\\.]+\\.(refNetWeightUnit)$`, "g").test(
                    field?.key
                );
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.addresses\\.[^\\.]+\\.(refAddressType|tel|fax|latitude|longitude|map)$`,
                    "g"
                ).test(field?.key);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.addresses\\.[^\\.]+\\.(noTh|roomTh|buildingTh|floorTh|villageTh|mooTh|soiTh|roadTh|refProvince|refAmphur|refTambon|postCode)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.addresses\\.[^\\.]+$`, "g").test(field?.key);
            },
            visibleField: ({ props, modelRef, model }) => {
                const { informKey } = props;
                const inform = informKey ? lodash.get(modelRef, informKey) : modelRef.refInformTemp;
                return (
                    (["16", "17"].includes(inform?.refRequestDoc?.key) && model.refHazSpecies?.key === "1") ||
                    ["02"].includes(inform?.refRequestDoc?.key)
                );
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refInformTemp\\.products\\.[^\\.]+\\.(isCheck|isSequestrate|isSampling)$`, "g").test(field?.key);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refInformTemp\\.attachments\\.[^\\.]+\\.(documentName|(attribute\\.(documentNo|documentDate|documentExpiredDate))|size)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, record }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                        if (record?.attribute?.isDisabledDocumentName) {
                            common.disabled = true;
                        }
                    }
                }
                return common;
            }
        },
        {
            check: ({ componentKey }) => {
                return new RegExp(`^${prefixRegExp}HazMainSubStanceList$`, "g").test(componentKey);
            },
            inputPropField: commonComponentProp({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ componentKey }) => {
                return ["AttachmentInlineList"].includes(componentKey);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let canCreate = false;
                let canDelete = false;
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(initialModel.refStatus?.key)) {
                    canCreate = !viewOnly || canCreate;
                    canDelete = !viewOnly || canDelete;
                }
                return { canCreate, canDelete };
            }
        },
        {
            check: ({ componentKey }) => {
                return new RegExp(`^${prefixRegExp}InformProductList$`, "g").test(componentKey);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                if (["02"].includes(modelRef.refRequestDoc?.key)) {
                    return { canCreate: false, canDelete: false };
                }
                return commonComponentProp({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["3", "4"]
                })({ modelRef, initialModel });
            }
        },
        {
            check: ({ componentKey }) => {
                return new RegExp(`^InformProductQtyList$`, "g").test(componentKey);
            },
            visibleField: ({ props, modelRef, model }) => {
                const { informKey } = props;
                const inform = informKey ? lodash.get(modelRef, informKey) : modelRef.refInformTemp;
                return (
                    (["16", "17"].includes(inform?.refRequestDoc?.key) &&
                        (model.refHazSpecies?.key === "1" || (model.refHazSpecies?.key !== "1" && model.refHaz))) ||
                    ["02", "18", "19"].includes(inform?.refRequestDoc?.key)
                );
            },
            inputPropField: ({ props, modelRef, initialModel, model }) => {
                const { viewOnly } = props;
                const common = commonComponentProp({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["3", "4"]
                })({ modelRef, initialModel });
                if (["16", "17"].includes(modelRef.refRequestDoc?.key)) {
                    if (common.canCreate === false || common.canDelete === false) {
                        common.canCreate = !viewOnly && model.refHazSpecies?.key !== "1";
                        common.canDelete = !viewOnly && model.refHazSpecies?.key !== "1";
                    }
                    common.visiblePagination = model.refHazSpecies?.key !== "1";
                    common.showStorageLocation = model.refHazSpecies?.key !== "1";
                    common.showLot = model.refHazSpecies?.key !== "1" && modelRef.refInformTemp.refOperation?.key === "2";
                } else if (["02", "18", "19"].includes(modelRef.refRequestDoc?.key)) {
                    common.canCreate = false;
                    common.canDelete = false;
                    common.visiblePagination = false;
                } else if (["20"].includes(modelRef.refRequestDoc?.key)) {
                    if (common.canCreate === false || common.canDelete === false) {
                        common.canCreate = !viewOnly && model.refHazSpecies?.key !== "1";
                        common.canDelete = !viewOnly && model.refHazSpecies?.key !== "1";
                    }
                    common.visiblePagination = model.refHazSpecies?.key !== "1";
                    common.showStorageLocation = model.refHazSpecies?.key !== "1" && modelRef.refInspectionTemp?.refRequestDoc?.key !== "02";
                    common.showLot =
                        model.refHazSpecies?.key !== "1" &&
                        modelRef.refInspectionTemp.refInformTemp?.refOperation?.key === "2" &&
                        modelRef.refInspectionTemp?.refRequestDoc?.key !== "02";
                } else if (["24"].includes(modelRef.refRequestDoc?.key)) {
                    if (common.canCreate === false || common.canDelete === false) {
                        common.canCreate = !viewOnly && model.refHazSpecies?.key !== "1";
                        common.canDelete = !viewOnly && model.refHazSpecies?.key !== "1";
                    }
                    common.visiblePagination = model.refHazSpecies?.key !== "1";
                    common.showStorageLocation =
                        model.refHazSpecies?.key !== "1" && modelRef.refReleaseTemp?.refInspection?.refRequestDoc?.key !== "02";
                    common.showLot =
                        model.refHazSpecies?.key !== "1" &&
                        modelRef.refReleaseTemp?.refInspection?.refInformTemp?.refOperation?.key === "2" &&
                        modelRef.refReleaseTemp?.refInspection?.refRequestDoc?.key !== "02";
                }
                return common;
            }
        },
        {
            check: ({ componentKey }) => {
                return new RegExp(`^SequestrateInfoForm`, "g").test(componentKey);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ componentKey }) => {
                return new RegExp(`^SamplingInfoForm`, "g").test(componentKey);
            },
            visibleField: () => {
                return false;
            }
        }
    ];
};

export const commonInputPropField = ({ disabledStatuses, disabledRequestTypes }) => ({ modelRef, initialModel }) => {
    let enabled = undefined;
    if (disabledStatuses.includes(initialModel.refStatus?.key) || disabledRequestTypes.includes(modelRef.refRequestType?.key)) {
        enabled = false;
    }
    return { disabled: enabled !== undefined ? !enabled : undefined };
};

export const commonComponentProp = ({ disabledStatuses, disabledRequestTypes }) => ({ modelRef, initialModel }) => {
    let canCreate = undefined;
    let canDelete = undefined;
    if (disabledStatuses.includes(initialModel.refStatus?.key) || disabledRequestTypes.includes(modelRef.refRequestType?.key)) {
        canCreate = false;
        canDelete = false;
    }
    return { canCreate, canDelete };
};

export const commonVisibleField = ({ invisibleRequestDocs }) => ({ modelRef }) => {
    let result = true;
    if (invisibleRequestDocs.includes(modelRef.refRequestDoc?.key)) {
        result = false;
    }
    return result;
};
